var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-dialog',{attrs:{"title":_vm.title,"name":_vm.dialogName},on:{"open":_vm.fetchResource,"closed":_vm.resetForm}},[_c('mf-form',{ref:"form",attrs:{"config":_vm.formConfig,"loading":_vm.loading,"parentData":( _obj = {}, _obj[_vm.ACTION_TYPE_KEY] = _vm.actionType, _obj )},on:{"submit":_vm.submitForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }